import { FaSearch } from "react-icons/fa";
import { useState, useEffect } from "react";
import { CiEdit } from "react-icons/ci";
import { MdOutlineDeleteOutline } from "react-icons/md";
import Swal from "sweetalert2";
import { getAllEmployeeWork } from "../apis/workApis";
import { useNavigate } from "react-router-dom";

const Works = () => {
  const [works, setWorks] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const employee = JSON.parse(localStorage.getItem("user"));
  const employeeId = employee?._id;

  useEffect(() => {
    getAllEmployeeWork()
      .then((res) => setWorks(res.data || []))
      .catch((err) => console.error(err));
  }, [employeeId]);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      confirmButtonText: "Yes, delete",
    }).then((result) => {
      if (result.isConfirmed) {
        setWorks((prev) => prev.filter((item) => item._id !== id));
        Swal.fire("Deleted!", "Work removed successfully.", "success");
      }
    });
  };

  const handleStartWork = (workId,teamId) => {
    navigate(`/work/${workId}/${teamId}`);
  };

  const filteredWorks = works.filter(
    (work) =>
      work.franchise?.franchiseName
        ?.toLowerCase()
        .includes(search.toLowerCase()) ||
      work.team?.name?.toLowerCase().includes(search.toLowerCase())
  );

  const statusColor = (status) => {
    if (status === "completed") return "bg-green-100 text-green-600";
    if (status === "pending") return "bg-yellow-100 text-yellow-600";
    if (status === "in progress") return "bg-blue-100 text-blue-600";
    return "bg-gray-300 text-gray-600";
  };

  return (
    <div className=" p-4 min-h-screen">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
        <h1 className="text-2xl font-bold text-gray-800">My Assigned Works</h1>
        <div className="relative w-full md:w-64">
          <input
            type="text"
            placeholder="Search work..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full py-2 pl-4 pr-10 text-sm border rounded-lg focus:ring-2 focus:ring-red-400 outline-none"
          />
          <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-red-500" />
        </div>
      </div>

      {/* Works Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
        {filteredWorks.length > 0 ? (
          filteredWorks.map((work) => (
            <div
              key={work._id}
              className="bg-white rounded-xl shadow hover:shadow-lg transition p-5 border flex flex-col justify-between"
            >
              {/* Header */}
              <div className="flex justify-between items-center mb-3">
                <h2 className="text-sm font-semibold text-gray-800">
                  {work.team?.name || "Team Name"}
                </h2>
                <span
                  className={`text-sm px-3 py-1 rounded-full capitalize ${statusColor(
                    work.status
                  )}`}
                >
                  {work.status || "unknown"}
                </span>
              </div>

              {/* Details */}
              <div className="text-sm text-gray-600 space-y-1 mb-4">
                <p>
                  <span className="font-medium">Franchise:</span>{" "}
                  {work.franchise?.franchiseName || "-"}
                </p>
                <p>
                  <span className="font-medium">Owner:</span>{" "}
                  {work.franchise?.name || "-"}
                </p>
                <p>
                  <span className="font-medium">Location:</span>{" "}
                  {work.franchise?.location || "-"}
                </p>
              </div>

              {/* Actions */}
              <div className="flex justify-end gap-3 mt-auto">
                {work.status !== "completed" && (
                  <button
                    onClick={() => handleStartWork(work.franchise._id, work.team._id)}
                    className="px-3 py-1 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
                  >
                    Start Work
                  </button>
                )}

                {/* <CiEdit
                  className="text-green-600 cursor-pointer hover:scale-110 transition"
                  fontSize={22}
                  title="Update Status"
                /> */}
              </div>
            </div>
          ))
        ) : (
          <p className="text-center col-span-full text-gray-500">
            No assigned works found
          </p>
        )}
      </div>
    </div>
  );
};

export default Works;
